import React, { useEffect } from 'react'
import dayjs from 'dayjs';
import { useTable, useGlobalFilter, usePagination, useFilters, useSortBy } from 'react-table'
import { COLORS, SCAN_TYPES } from '../../config';
import TrashIcon from '../../components/Icons/solid/TrashIcon';
import TablePaginationBasic from '../ReactTable/TablePaginationBasic';
import SortAscSmall from '../../components/Icons/solid/SortAscSmall';
import SortDescSmall from '../../components/Icons/solid/SortDescSmall';
import EyeIcon from '../../components/Icons/solid/EyeIcon';
import useScans from '../../store/scans/scansContext';
import AddScanModal from './AddScanModal';
import SecondaryButtonAccent from '../../components/Buttons/SecondaryButtonAccent';
import UploadIcon from '../../components/Icons/outline/UploadIcon';
import DownloadIcon from '../../components/Icons/outline/DownloadIcon';
import ScanViewerModal from './STLViewerModal';
import { MoonLoader } from 'react-spinners';
import useApp from '../../store/app/appContext';

function ScanFiles({
  scanId,
  scanType,
  patientName
}) {
  
  //get files, upload document, delete document
  const {
    getScanFiles,
    deleteScanFile,
    downloadScanFile,
    uploadScanFile,
    getScanFile,
  } = useScans();

  const {
    appState: { userAccount },
  } = useApp();

  const [showSTL, setShowSTL] = React.useState(false);
  const [minHeight, setMinHeight] = React.useState('auto');
  const [showAddScan, setShowAddScan] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [scanFiles, setScanFiles] = React.useState([]);
  const [selectedScan, setSelectedScan] = React.useState();
  const [isFileUpload, setIsFileUpload] = React.useState(false);

  // fetch files
  useEffect(() => {
    getScanFiles(scanId).then(res=>{
      setIsLoading(false)
      setScanFiles(res.data)
    }).catch(e=> setIsLoading(false))
  }, []);
  
  
  //all formatted files
  
  

    const data = React.useMemo(() => {
      let _data = [];
      if (scanFiles.length) {
        _data = scanFiles.map(document => ({
          fileName: document.name,
          lastModified: dayjs(document.last_modified).format('YYYY-MM-DD'),
          size: Math.round(document.size / 1000) + ' KB',
        }))
      };
      return _data
    }, [scanFiles])
    
    useEffect(() => {
      if (data.length) return setMinHeight('502px');
      return setMinHeight('auto');
    }, [data])
    
    const columns = React.useMemo(
    () => [
      {
        Header: 'File name',
        accessor: 'fileName',
      },
      {
        Header: 'Last modified',
        accessor: 'lastModified',
      },
      {
        Header: 'Size',
        accessor: 'size',
      },
    ], []
  );
  
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    gotoPage,
    prepareRow,
    state : { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  
  const handleDeleteDocument = (row) => {
    const documentName = scanFiles[row].name;
    deleteScanFile(scanId, documentName).then(()=>{
      setScanFiles((scanFiles.filter(file=>file.name !== documentName)))
    })
  }

  const handleDownloadDocument = (row) => {
    const documentName = scanFiles[row].name;
    downloadScanFile(scanId, documentName);
  }

  const handleGetDocument = (row) => {
    const documentName = scanFiles[row].name;
    getScanFile(scanId, documentName).then(data=>{
      setShowSTL(data?.downloadUrl)
      setSelectedScan(documentName)
    })
  }

  const handleFileUpload = (files) => { 
    if (files) {
      setIsFileUpload(true)
      // setShowAddScan(false)
      uploadScanFile(scanId, files).then(res =>{
        getScanFiles(scanId).then((res)=>{
          setIsFileUpload(false)
          setScanFiles(res.data)
          setShowAddScan(false)
        })
      }).catch(e => {
        setIsFileUpload(false)
      })
    }
  }

  const handleViewDocument = (row) => {
    handleGetDocument(row)
  }

  const handleDownloadScanDocument = (row) => {
    handleDownloadDocument(row)
  }

  const onCloseSTLModal = () => {
    setShowSTL(false)
    setSelectedScan(false)
  }

  const closeModal = () => {
    if(!isFileUpload) {
      setShowAddScan(false);
    }
  }

  return (
    <div className='bg-white rounded shadow p-10 flex flex-col' style={{ minHeight: minHeight }}>
      {/* {isFileUpload && (
        <div className='inset-2/4 flex absolute w-full m-10' >
          <div className='rounded-lg shadow-xl flex justify-around min-h-170 pr-20 pl-20 items-center' style={{border: '1px solid lightgray', background: 'white'}}>
            <MoonLoader color={COLORS.colorPrimary}/>
           </div> 
        </div>
      )} */}
      <AddScanModal isFileUpload={isFileUpload} scanType={scanType} showAddScan={showAddScan} closeModal={closeModal} handleFileUpload={handleFileUpload}/>
      <ScanViewerModal scanId={scanId} scanType={scanType} showSTL={showSTL} setShowSTL={setShowSTL} patientName={patientName} scanName={selectedScan} onClose={onCloseSTLModal}/>
      <div className='flex justify-between mb-10 '>
        <h1 className="text-2xl text-secondary">Scans</h1>
        <div className='flex space-x-2'>
          <SecondaryButtonAccent disabled={isFileUpload} onClick={() => setShowAddScan(true)} text="Upload file" icon={<UploadIcon fill={COLORS.colorPrimary}/>} /> 
        </div>
      </div>
      <div className='w-full mb-auto rounded bg-white'>
        {!!data.length && 
        <div className='overflow-x-scroll'>
          <table {...getTableProps()} className='w-full p-2 xl:p-4 mt-4 border-transparent'>
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())} className='text-secondary xl:px-2 pb-3 border-b-2 border-gray-100 text-left text-base font-semibold'>
                    <span className='flex items-center'>
                    {column.render('Header')}
                    {column.isSorted ? 
                      column.isSortedDesc ? 
                        
                        <SortAscSmall style={'ml-1 h-5 w-5'}/>
                        
                        : <SortDescSmall style={'ml-1 h-5 w-5'} />
                    : ''}
                    </span>
                  </th>
                  ))}
                  <th className='text-left xl:px-2 pb-3 border-b-2 border-gray-100 '></th>
                </tr>
              ))}
            </thead>
             <tbody {...getTableBodyProps()} className=''>
            {page.map(row => {
              prepareRow(row)
              if (page.indexOf(row) === (page.length - 1)) {
                return (
                  <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    if (cell.column.id === 'fileName') {
                      return (
                        <td {...cell.getCellProps()} className='text-gray-500 font-medium xl:px-2 py-3'>
                        {cell.render('Cell')}
                        </td>
                      )
                    };
                    return (
                      <td {...cell.getCellProps()} className='text-gray-500  xl:px-2 py-3'>
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                   <td className='text-left xl:px-2'>
                    <div className=' flex flex-row-reverse items-center'>
                      {!userAccount.isPatientOrPartner && <TrashIcon className='ml-2 cursor-pointer' vertical fill={COLORS.colorShade} onClick={() => handleDeleteDocument(row.index)}/>}
                      <EyeIcon className='ml-2 cursor-pointer' vertical fill={COLORS.colorShade} onClick={() => handleViewDocument(row.index)}/>
                      <DownloadIcon className='ml-2 cursor-pointer' vertical stroke={COLORS.colorShade} onClick={() => handleDownloadScanDocument(row.index)}/>
                    </div>
                  </td>
                  </tr>
                )
              }
              return (
                <tr {...row.getRowProps()} className={`border-b-2 border-gray-100`}>
                  {row.cells.map(cell => {
                    if (cell.column.id === 'fileName') {
                      return (
                        <td {...cell.getCellProps()} className='text-gray-500 font-medium xl:px-2 py-3'>
                        {cell.render('Cell')}
                        </td>
                      )
                    };
                    return (
                      <td {...cell.getCellProps()} className='text-gray-500  xl:px-2 py-3'>
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                  <td className='text-left xl:px-2'>
                    <div className=' flex flex-row-reverse items-center'>
                      {!userAccount.isPatientOrPartner && <TrashIcon className='ml-2 cursor-pointer' vertical fill={COLORS.colorShade} onClick={() => handleDeleteDocument(row.index)}/>}
                      <EyeIcon className='ml-2 cursor-pointer' vertical fill={COLORS.colorShade} onClick={() => handleViewDocument(row.index)}/>
                      <DownloadIcon className='ml-2 cursor-pointer' vertical stroke={COLORS.colorShade} onClick={() => handleDownloadScanDocument(row.index)}/>
                   
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        </div>
        }
        {scanFiles.length && !data.length ?
        <span>No files have been uploaded for this scan.</span> : <span></span>
        }
      </div>
      { isLoading ? 
      <div className='flex justify-around min-h-170 pt-8'>
        <MoonLoader color={COLORS.colorPrimary}/>
      </div> 
      : !!data.length && 
      <div className='pt-10 pb-4'>
        <TablePaginationBasic   
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          canPreviousPage={canPreviousPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          gotoPage={gotoPage}
        />
      </div>
      }
    </div>
  );  
}

export default ScanFiles;
